import React, { useState } from "react";
import Style from "../style/forget.module.scss";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError("Please enter your email");
      return;
    }
    setError("");
    setLoading(true);

    try {
      const response = await fetch("/api/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        alert("Check your email for a reset link");
        setEmail("");
      } else {
        setError("Failed to send reset link. Try again later.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={Style.pageWrapper}>
      <div className={Style.overlay} />
      <div className={Style.textBlock}>
        <h1 className={Style.mainHeading}>Reset Your Password</h1>
        <p className={Style.subText}>
          Enter your registered email below to receive a password reset link.
        </p>
      </div>

      <div className={Style.formContainer}>
        <h2 className={Style.formTitle}>Forgot Password</h2>
        <form onSubmit={handleSubmit}>
          <div className={Style.formGroup}>
            <input
              type="email"
              id="email"
              className={Style.inputField}
              value={email}
              onChange={handleEmailChange}
              placeholder=" "
              required
            />
            <label htmlFor="email">Email Address</label>
          </div>
          {error && <p className={Style.error}>{error}</p>}
          <button
            type="submit"
            className={`${Style.submitButton} ${loading ? "loading" : ""}`}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
